import { combineReducers } from 'redux';

import {
    REQUEST_EBONS_REMINDER,
    SUCCESS_EBONS_REMINDER,
    FAILURE_EBONS_REMINDER,
    RESET_FORM_SUBMIT_SEND_EBON_REMINDER
} from './constants';

const mailSent = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_EBONS_REMINDER:
            return action.response.payload;
        case RESET_FORM_SUBMIT_SEND_EBON_REMINDER:
            return false;
        default:
            return state;
    }
};

const successSubmit = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_EBONS_REMINDER:
            return true;
        case REQUEST_EBONS_REMINDER:
        case FAILURE_EBONS_REMINDER:
        case RESET_FORM_SUBMIT_SEND_EBON_REMINDER:
            return false;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_EBONS_REMINDER:
            return true;
        case FAILURE_EBONS_REMINDER:
        case SUCCESS_EBONS_REMINDER:
        case RESET_FORM_SUBMIT_SEND_EBON_REMINDER:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_EBONS_REMINDER:
            return action.response.message;
        case REQUEST_EBONS_REMINDER:
        case SUCCESS_EBONS_REMINDER:
        case RESET_FORM_SUBMIT_SEND_EBON_REMINDER:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    mailSent,
    successSubmit,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/ebonReminder/reducer.js